import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionContractApi = {
    getInstitutionContractByInstitutionId: (institutionId: number): Observable<Dtos.GetInstitutionContractByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionContractByInstitutionId = new Dtos.GetInstitutionContractByInstitutionId();
        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionContractByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionContractById: (id: number): Observable<Dtos.GetInstitutionContractByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionContractById = new Dtos.GetInstitutionContractById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionContractByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionContract: (institutionContract: Dtos.InstitutionContract): Observable<Dtos.SetInstitutionContractResponse> => {

        let request: Dtos.SetInstitutionContract = new Dtos.SetInstitutionContract();

        request.institutionContract = institutionContract;

        // send request
        const response: Promise<Dtos.SetInstitutionContractResponse> = client.post(request);

        return Observable.from(response);
    },
    createInstitutionContract: (institutionId: number): Observable<Dtos.CreateInstitutionContractResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionContract = new Dtos.CreateInstitutionContract();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionContractResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionContract: (institutionContract: Dtos.InstitutionContract): Observable<Dtos.ValidateInstitutionContractResponse> => {

        let request: Dtos.ValidateInstitutionContract = new Dtos.ValidateInstitutionContract();

        request.institutionContract = institutionContract;

        // send request
        const response: Promise<Dtos.ValidateInstitutionContractResponse> = client.post(request);

        return Observable.from(response);
    },
}